import { combineReducers } from "redux";

import {allowedNavigationDetails} from "./reducer.permission"

const allowedNavigationReducers = combineReducers({
  allowedNavigationDetails
})
export default allowedNavigationReducers;
